export interface ElementOption {
  id?: string;
  class?: string | string[];
  attrs?: {
    [key: string]: string;
  }
}

export const num = (value: any, defaultValue: number = 0) => {
  const cast = Number(value);
  if (value == null || Number.isNaN(cast)) {
    return defaultValue;
  }
  return cast;
}

export const bool = (input: any) => {
  if (input === 1) return true;
  if (typeof input === 'boolean') return input;
  if (typeof input === 'string') {
    input = input.toLowerCase();
    if (input === 'true') {
      return true;
    }
  }
  return false;
}

export const attr = (element: HTMLElement, key: string, defaultValue?: any): any => {
  const value = element.getAttribute(key);
  if (value === undefined) {
    if (!defaultValue) {
      return null;
    }
    return defaultValue;
  }
  return value as string;
};

export const parent = (element: HTMLElement, depth: number = 1): HTMLElement | null => {
  for (let i = 0; i < depth; i++) {
    const parent = element.parentElement;
    if (parent == null) {
      return parent;
    }
    element = parent;
  }
  return element;
}

export const element = (tag: string, options?: ElementOption) => {
  if (typeof options !== 'object') options = {};
  const element = document.createElement(tag);
  if (options.id) element.id = options.id;
  if (options.class) {
    if (!Array.isArray(options.class)) {
      options.class = [options.class];
    }
    options.class.forEach(item => element.classList.add(item));
  }
  if (options.attrs) {
    for (const key in options.attrs) {
      if (options.attrs.hasOwnProperty(key)) {
        const value = options.attrs[key];
        element.setAttribute(key, value);
      }
    }
  }
  return element as HTMLElement;
}

export const event = (element: HTMLElement, type: string, callback: any) => {
  return element.addEventListener(type, callback);
}

export const removeEvent = (element: HTMLElement, type: string, callback: any) => {
  return element.removeEventListener(type, callback);
}

export const getElementByTag = (name: string) => {
  return document.getElementsByTagName(name)[0] as HTMLElement;
}

export const isReactClassComponent = (component: any) => {
  return typeof component === 'function' &&
    (component.prototype && !!component.prototype.isReactComponent);
}

export const range = (start: number, end: number, step: number = 1) => {
  let arr = []
  for (let n = start; n < end; n += (step || 1)) arr.push(n)
  return arr;
}

export const encodeQuery = (params: URLSearchParams) => {
  const ret = [];
  for (const param of (params as any)) {
    ret.push(encodeURIComponent(param[0]) + '=' + encodeURIComponent(param[1]));
  }
  return ret.join('&');
}

export const inheritUrl = (base = '', custom?: any) => {
  const params = new URLSearchParams(window.location.search);
  if (custom) {
    for (const key in custom) {
      if (Object.prototype.hasOwnProperty.call(custom, key)) {
        const value = custom[key];
        params.set(key, String(value));
      }
    }
  }
  const queryString = encodeQuery(params);
  return `${base}?${queryString}`;
}

export const queryParams = () => {
  const params = new URLSearchParams(window.location.search);
  const result = {};
  for (const param of (params as any)) {
    result[param[0]] = param[1];
  }
  return result;
}

export const arrayFill = (length: number, values: any) => {
  return Array(length).fill(values);
}

export const round = (value: number, precision: number) => {
  const multiplier = Math.pow(10, precision || 0);
  return Math.round(value * multiplier) / multiplier;
}

export const ucfirst = (text: string) => {
  return text.charAt(0).toUpperCase() + text.slice(1);
}

export const uclast = (text: string) => {
  return text.charAt(text.length - 1).toUpperCase() + text.slice(1);
}

export const traverseChildren = (element: HTMLElement) => {
  const children = [];
  const queue = [];
  queue.push(element);
  while (queue.length > 0) {
    var current = queue.pop();
    children.push(current);
    pushAll(current.children);
  }
  function pushAll(elemArray: any[]) {
    for (var i = 0; i < elemArray.length; i++) {
      queue.push(elemArray[i]);
    }

  }
  return children;
}
